// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 25 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M16.0703 3.34403L14.6423 4.12503L16.0703 4.90604L16.8513 6.33405L17.6323 4.90604L19.0603 4.12503L17.6323 3.34403L16.8513 1.91602L16.0703 3.34403ZM2.22632 12C2.22632 6.47719 6.70347 2.00003 12.2263 2.00003H13.96L13.0919 3.50073C12.5134 4.50094 12.2263 5.68851 12.2263 7.00003C12.2263 10.866 15.3603 14 19.2263 14C19.6881 14 20.1385 13.9555 20.5738 13.8707L22.2564 13.5428L21.7135 15.1689C20.3886 19.1373 16.6431 22 12.2263 22C6.70347 22 2.22632 17.5229 2.22632 12ZM20.7263 6.41602L21.6399 8.08645L23.3103 9.00003L21.6399 9.91362L20.7263 11.5841L19.8127 9.91362L18.1423 9.00003L19.8127 8.08645L20.7263 6.41602Z"}}]};

const ModeDarkFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'mode-dark-filled',
    ref,
    icon: element,
  },
));

ModeDarkFilledIcon.displayName = 'ModeDarkFilledIcon';

export default ModeDarkFilledIcon;
